import React from 'react'
import { Grid, Typography, LinearProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const fmt = (v) => (v || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
const pct = (v) => ((v || 0) * 100).toFixed(1) + '%'

const marginColor = (margin) => {
  const m = (margin || 0) * 100
  if (m >= 20) return '#4caf50'
  if (m >= 10) return '#ff9800'
  return '#f44336'
}

const coverageColor = (covered, total) => {
  if (!total) return '#9e9e9e'
  const ratio = covered / total
  if (ratio >= 0.9) return '#4caf50'
  if (ratio >= 0.5) return '#ff9800'
  return '#f44336'
}

const GreenProgress = withStyles({
  root: { height: 6, borderRadius: 3 },
  colorPrimary: { backgroundColor: '#e0e0e0' },
  bar: { borderRadius: 3, backgroundColor: '#2e7d32' }
})(LinearProgress)

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  padding: 16,
  textAlign: 'center'
}

const SummaryCards = ({ summary }) => {
  if (!summary) return null

  const { totalCost, totalSell, margin, totalItems, coveredItems } = summary
  const coveragePct = totalItems ? Math.round((coveredItems / totalItems) * 100) : 0

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <div style={cardStyle}>
          <Typography variant="caption" style={{ color: '#666', textTransform: 'uppercase', fontSize: 11 }}>
            Total Cost
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 700, marginTop: 4 }}>
            {fmt(totalCost)}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <div style={cardStyle}>
          <Typography variant="caption" style={{ color: '#666', textTransform: 'uppercase', fontSize: 11 }}>
            Total Sell
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 700, marginTop: 4 }}>
            {fmt(totalSell)}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <div style={cardStyle}>
          <Typography variant="caption" style={{ color: '#666', textTransform: 'uppercase', fontSize: 11 }}>
            Margin
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 700, marginTop: 4, color: marginColor(margin) }}>
            {pct(margin)}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <div style={cardStyle}>
          <Typography variant="caption" style={{ color: '#666', textTransform: 'uppercase', fontSize: 11 }}>
            Coverage
          </Typography>
          <Typography variant="h5" style={{ fontWeight: 700, marginTop: 4, color: coverageColor(coveredItems, totalItems) }}>
            {coveredItems || 0}/{totalItems || 0} items
          </Typography>
          <GreenProgress
            variant="determinate"
            value={coveragePct}
            style={{ marginTop: 8 }}
          />
        </div>
      </Grid>
    </Grid>
  )
}

export default SummaryCards
